module.exports = __webpack_public_path__ + "static/media/great.68befe04.png";